// Generato automaticamente prima di ogni compilazione. Non modificare a mano.
export const VERSIONE_BUILD = 'Build 2026.11.04-160159';
export const DATA_VERSIONE_BUILD = '04/11/2026 · 16:01';
